import * as actionTypes from './subActionMenuActionTypes';

const initialState = {
    SubActionMenuAnchorEl: null,
    SubActionMenuPlacement: "",
    SubActionMenuOpen: false,
    SubActionMenuId:undefined

}

export default function subActionMenuReducer(state = initialState, action) {

    switch (action.type) {
        case (actionTypes.SET_SUB_ACTION_MENU_ANCHOR_EL):
            if (action.subAnchorEl !== state.SubActionMenuAnchorEl) {
                return Object.assign({}, state, { SubActionMenuAnchorEl: action.subAnchorEl });
            }
            return state

        case (actionTypes.SET_SUB_ACTION_MENU_PLACEMENT):
            if (action.subPlacement !== state.SubActionMenuPlacement) {
                return Object.assign({}, state, { SubActionMenuPlacement: action.subPlacement });
            }
            return state;
        case (actionTypes.SET_SUB_ACTION_MENU_OPEN):
            if (action.open !== state.SubActionMenuOpen) {
                return Object.assign({}, state, { SubActionMenuOpen: action.open });
            }
            return state;
        case (actionTypes.SET_SUB_ACTION_MENU_ID):
            if (action.id !== state.SubActionMenuId) {
                return Object.assign({}, state, { SubActionMenuId: action.id });
            }
            return state;


        default:
            return state;
    }
}


